import React from 'react';
import { Text } from '@wix/design-system';
export const HeaderLine = ({ children, ...props }) => (React.createElement(Text, { size: "small", weight: "bold", secondary: true, ...props }, children));
//# sourceMappingURL=HeaderLine.js.map